import absoluteUrl from '@lib/routes/helpers/absoluteUrl'
import urlWithQueryParams from '@lib/routes/helpers/urlWithQueryParams'
import type { StringDictionary } from '@lib/types/dictionary'
import { redirect } from 'next/navigation'

/**
 * Use the Next.js App Router client side navigation to redirect to a new page.
 * Note: this is not necessarily a client component.
 * */
export function appRouterRedirect(
  path: string,
  urlParams?: string | URLSearchParams | StringDictionary,
) {
  return redirect(absoluteUrl(urlWithQueryParams(path, urlParams)))
}
